
export default class Accordion {
	constructor(el) {
		this.el = el;

		this.trigger = this.el.querySelector('.accordion__trigger');
		this.content = this.el.querySelector('.accordion__content');
		this.container = this.el.querySelector('.accordion__content__container');
		this.listItems = [...this.el.querySelectorAll('li')];

		this.isOpen = false;

		this.init();
		this.events();
	}

	init() {
		if (this.listItems) {
			this.listItems.forEach(li => {
				li.innerHTML = `<div class="li-arrow"><span></span><span></span><span></span></div>` + li.innerHTML;
			});
		}
	}

	events() {
		this.trigger.addEventListener('click', this.toggle.bind(this));
		window.addEventListener('resize', this.resizeHandle.bind(this));
	}

	// toggle accordion
	toggle() {
		this.isOpen ? this.close() : this.open();
	}

	// open accordion=
	open() {
		this.el.classList.add('is-open');
		this.setContentHeight();
		this.isOpen = true;
	}

	// close accordion
	close() {
		this.el.classList.remove('is-open');
		this.content.removeAttribute('style');
		this.isOpen = false;
	}

	// get the height of accordion content container
	containerHeight() {
		return `${this.container.getBoundingClientRect().height}px`;
	}

	// set content height to height of content container
	setContentHeight() {
		this.content.style.height = this.containerHeight();
	}

	resizeHandle() {
		if (this.isOpen) {
			this.setContentHeight();
		}
	}

}